import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { PageHeading } from "../../components/Heading/component";
import Ad from "../../components/Ad/component";
import { useDispatch, useSelector } from "react-redux";
import { nativeAdEnabled } from "../../utils/advertising/library";
import {
    OVERRIDE_SLIDER_VIDEOS,
    HIDE_SLIDER_ON_SECTION,
    HIDDEN_PAGE_HEADING,
} from "./constants";
import { CAROUSEL_STORIES_MAX_COUNT } from "../../constants/content";
import { getPageIntro } from "../../utils/pageIntro/library";
import {
    TITLES_KEYS_ARRAY,
    TITLES_VALUES_ARRAY,
} from "../../constants/sections";
import { fetchLandingPageData } from "../Landing/initData";
import PageAnalytics from "../../components/PageAnalytics";
import { getLandingAnalytics } from "../../utils/analytics/library";
import MaybeError from "../../components/MaybeError/component";
import { TYPE_LANDING } from "../../utils/analytics/constants";
import { PAGE_COMPONENT_UNIVERSAL_CLASS_NAME } from "../../constants/page";
import ContentArea from "../../components/ContentArea/async.component";
import Slider from "../../components/Slider/component";
import { fetch_content_load_more } from "../../actions/Content/dispatchers";
import usePageFetch from "../../hooks/usePageFetch";
import styles from "../../components/Slider/styles/themes/default.module.scss";

const LandingSports = ({ match, viewport }) => {
    const dispatch = useDispatch();
    const fetchData = () => {
        dispatch(fetchLandingPageData(match.url, match.params));
    };
    const path = useSelector((state) => state.app.path);
    const baseSection = useSelector((state) => state.app.baseSection);
    const subSection = useSelector((state) => state.app.subSection);
    const pageType = useSelector((state) => state.app.pageType);
    const list = useSelector((state) => state.content.list);
    const hasNextPage = useSelector((state) => state.content.hasNextPage);
    const contentPackage = useSelector((state) => state.content.contentPackage);
    const statusCode = useSelector((state) => state.app.statusCode);
    const meta = useSelector((state) => state.app.meta);
    const analytics = useSelector((state) => state.tracking);
    const rightrail = useSelector((state) => state.rightRail);
    const [nativeAdFailed, nativeAdCallback] = useState(null);

    usePageFetch(match, fetchData);

    const getCustomTitle = (title) => {
        let newTitle = null;
        TITLES_KEYS_ARRAY.map((url, i) => {
            if (title === url) {
                newTitle = TITLES_VALUES_ARRAY[i];
            }
        });
        return newTitle || subSection;
    };

    // If the Native Ad has been enabled, request it
    const hasNativeAd = nativeAdEnabled(baseSection);

    const noHeading = true;
    const pageIntro = getPageIntro({
        path,
        subSection,
        baseSection,
        pageType,
        noHeading,
        rightrail,
    });

    const contentProps = {
        content: list,
        viewport,
        hasTopStories: true,
        hasNativeAd,
        nativeAdFailed,
        nativeAdCallback,
        contentPackage,
        loadMore: hasNextPage ?? false,
        loadMoreFetch: fetch_content_load_more(path),
    };
    const analyticsProps = getLandingAnalytics({ meta, analytics });
    const a11yTitle = getCustomTitle(path);
    let sliderProps = null;

    // Before the data gets fetched, it has to call the slider component to get it
    if (subSection !== "video") {
        let header = "Top Videos";
        let section = "sports/video";

        if (OVERRIDE_SLIDER_VIDEOS[path]) {
            section = OVERRIDE_SLIDER_VIDEOS[path];
            header = `Top ${a11yTitle} Videos`;
        }

        sliderProps = {
            header: header,
            section: section,
            itemCount: CAROUSEL_STORIES_MAX_COUNT,
            viewport: viewport,
        };

        if (HIDE_SLIDER_ON_SECTION[path]) {
            sliderProps = null;
        }
    }

    const bottomPageAd = (
        <Ad type="intercept" targeting={{ plc: "feed" }} lazy={true} />
    );
    return (
        <MaybeError statusCode={statusCode}>
            <div
                className={classNames(
                    "landingSports",
                    styles.landingSports,
                    PAGE_COMPONENT_UNIVERSAL_CLASS_NAME
                )}
                data-testid="landing-sports"
            >
                {pageIntro}
                <PageHeading
                    text={a11yTitle}
                    hidden={!!HIDDEN_PAGE_HEADING[path]}
                />
                {path === "sports" && sliderProps && (
                    <Slider {...sliderProps} />
                )}
                <ContentArea {...contentProps} />
                {bottomPageAd}
                <PageAnalytics dtmData={analyticsProps} type={TYPE_LANDING} />
            </div>
        </MaybeError>
    );
};

LandingSports.propTypes = {
    match: PropTypes.object.isRequired,
    viewport: PropTypes.string.isRequired,
};

export default LandingSports;
